export class NoticeSetting {
  id: number;
  footprint: boolean;
  no_reply_chat: boolean;
  email_stamp: boolean;
  email_get_message: boolean;
  email_footprint: boolean;
  email_other: boolean;
  camouflage: boolean;
  extra_time: boolean;
  constructor(fields: any) {
    for (const f in fields) {
      this[f] = fields[f];
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/notice-setting.ts